import { ImpButton } from '@imprint-payments/imprint-ui';
import { useEffect } from 'react';

import { EVENT } from '../../analytics/analyticsConsts';
import { getCounterOffer, getRejectionReasons } from '../../api/api';
import { useImpState } from '../../app/hooks';
import { ANALYTICS } from '../../firebase/firebase';
import ButtonServicing, {
  ButtonColorScheme,
} from '../buttonServicing/ButtonServicing';
import Spinner from '../spinner/Spinner';
import styles from './Modal.module.css';

export default function WaterfallModal({
  handleViewDeclineDetailsClick,
  showApplyAgainButton,
  handleApplyAgainClick,
}: {
  handleViewDeclineDetailsClick: () => void;
  showApplyAgainButton?: boolean;
  handleApplyAgainClick?: () => void;
}) {
  const {
    language,
    languageCode,
    dispatch,
    merchantData,
    appScreenState,
    appStatus,
  } = useImpState();
  const counterOffer = merchantData.counterOffer;

  useEffect(() => {
    if (appStatus.applicationUUID) {
      dispatch(
        getRejectionReasons({
          applicationUUID: appStatus.applicationUUID,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appStatus.applicationUUID]);

  useEffect(() => {
    dispatch(getCounterOffer(merchantData.productUUID, languageCode));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantData.productUUID, language]);

  useEffect(() => {
    ANALYTICS.logEvent(EVENT.COUNTEROFFER_VIEWED);
  }, []);

  function handleLinkClick() {
    ANALYTICS.logEvent(EVENT.COUNTEROFFER_VISIT_CLICKED);
    window.open(counterOffer.url, '_blank');
  }

  if (!counterOffer || counterOffer.image == '' || appScreenState.loading) {
    return <Spinner />;
  }

  return (
    <div className={styles.waterfallContainer}>
      <div className={styles.waterfallTitle}>{language.waterfallTitle}</div>
      <div className={styles.waterfallSubtitles}>
        <p>{language.waterfallSubtitle1}</p>
        {showApplyAgainButton ? (
          <>
            {language.waterfallSubtitle3}
            <ImpButton
              variant="inline"
              buttonStyle="branded"
              onClick={handleApplyAgainClick}
            >
              {language.waterfallSubtitle4}
            </ImpButton>
            {language.period}
          </>
        ) : (
          <p>{language.waterfallSubtitle2}</p>
        )}
      </div>
      <ButtonServicing
        colorScheme={ButtonColorScheme.emptyBranded}
        value={language.viewDeclineDetailsBtn}
        overrideColor={counterOffer.lightModeColor}
        handleClick={handleViewDeclineDetailsClick}
      />
      <div
        className={styles.waterfallImageSection}
        style={{ borderColor: counterOffer.lightModeColor }}
      >
        <p
          className={styles.waterfallImageTitle}
          dangerouslySetInnerHTML={{
            __html: counterOffer.title?.replace(
              counterOffer.titleHighlight,
              '<b>' + counterOffer.titleHighlight + '</b>'
            ),
          }}
        />
        <p>{counterOffer.subtitle}</p>
        <img
          className={styles.waterfallCard}
          src={counterOffer.image}
          alt="counteroffer"
        />
        <ButtonServicing
          colorScheme={ButtonColorScheme.emptyBranded}
          value={counterOffer.hyperlinkButtonName}
          overrideColor={counterOffer.lightModeColor}
          handleClick={handleLinkClick}
        />
      </div>
      <div className={styles.waterfallDisclaimers}>
        <p dangerouslySetInnerHTML={{ __html: counterOffer.disclosure }} />
      </div>
    </div>
  );
}
